// Get all donation options
var donateOptions = document.querySelectorAll('.donate-option');
// get the main input used for the donation amount ( sent to stripe )
var donateInput = document.querySelector('#sos-amount');

/*
 * A function to highlight a new option element and deslect all other options
 * 
 * If no element is passed then it will assume that you want to highlight the
 * 'other' option
 *
 * @param {Node}(optional) The option element to toggle to
 */
function toggleActiveOption(toSelect) {
    // When there is no specific element to highlight
    if (toSelect == null) {

        // Then we should use the 'other' amount
        toSelect = document.querySelector('.donate-option[data-value=other]')
    }

    // The active option is the one that is selected
    var activeOption = document.querySelector('.donate-option.is-selected');

    // Deactive any already active
    activeOption.classList.remove('is-selected');

    // Activate the desired option
    toSelect.classList.add('is-selected');

    updateDonationValueText(toSelect);
}

/*
 * Take the current value from the dontaInput and update the value of the text
 * in the form footer.
 */
function updateConfirmAmount() {

    // The helper text in the form footer
    var confirmAmount = document.querySelector('.js-donate-confirm-amount');
    // The main input used for donation amount
    var donateInput = document.querySelector('#sos-amount');

    // Get the current value from the main input
    var currentAmount = donateInput.value;

    if (confirmAmount) {
        // If there is nothing input ...
        if( currentAmount == '') {
            // ... then assume zero amount
            confirmAmount.innerHTML = '0';
            // Check if the vlaue is a number
        } else if ( ! isNaN( currentAmount ) ) {
            // Then update the helper text
            confirmAmount.innerHTML = currentAmount;
        } else {
            // Otherwise assume zero amount
            confirmAmount.innerHTML = '0';
        }
    }

}

/*
 * When the user wants a dontation amount that is different from the presets
 */
function customDonateAmount() {

    // Select the 'other' amount
    toggleActiveOption();

    // Update the value in the form footer
    updateConfirmAmount();

    validateAmount();
}

/*
 * This will check against the current value in the donateInput and check it
 * against the supplied doantion option element. Best used in a loop checking
 * each option against the input value to find a match
 *
 * @param {Node} The donation amount option to check against
 */
function syncInputWithOptions(option) {
    // The main donation input
    var donateInput = document.querySelector('#sos-amount');

    // The amount stored in the option supplied
    var optionValue = option.getAttribute('data-value');

    // If these two are the same
    if (donateInput.value == optionValue) {
        // Then update which is visually selected
        toggleActiveOption(option);
    }

    // If there is nothing in the input
    if (donateInput.value == '') {
        // Update the 'other' amount
        toggleActiveOption();
        // get the helper text
        var confirmAmount = document.querySelector('.js-donate-confirm-amount');
        // And set that to zero amount
        confirmAmount.innerHTML = '0';
    }

}

/*
 * Take the text data from the option and update the text describing what that
 * money could buy
 * 
 * @param {Node} The active option element
 */
function updateDonationValueText(activeOption) {
    // Get the text to change to
    var text = activeOption.getAttribute('data-text');
    // Get the area it will display in
    var textDisplayArea = document.querySelector('.donate-options-text');

    if (textDisplayArea) {
        // Hide the text area
        textDisplayArea.style.opacity = 0
        setTimeout(function() {
            // Update the text
            textDisplayArea.innerHTML = text;
            // Show the area
            textDisplayArea.style.opacity = 1
            // After 300 milliseconds
        }, 300);
    }
}

/*
 * Check the input amount is more than zero
 *
 * @param {Node} Where the error massage is
 * @param {int} The donation amount
 * @param {Node} The submit button to enable / diable
 */
function valueIsPositive(errorMessage, value, button) {
    if (value === '') {
        // nothing to validate
        button.setAttribute('disabled', true);

    } else if ( value < 0) {
        button.setAttribute('disabled', true);
        errorMessage.innerHTML = 'sorry, you can\'t donate less than nothing';
        errorMessage.style.display = 'block';

        return false;
    } else {
        button.removeAttribute("disabled");
        errorMessage.style.display = 'none';

        return true;
    }
}

/*
 * Check the input amount is a number
 *
 * @param {Node} Where the error massage is
 * @param {int} The donation amount
 * @param {Node} The submit button to enable / diable
 */
function isANumber(errorMessage, value, button) {
    if ( isNaN( value ) ) {
        button.setAttribute('disabled', true);

        errorMessage.innerHTML = 'It needs to be a valid amount of money';
        errorMessage.style.display = 'block';

    } else {
        button.removeAttribute('disabled');
        errorMessage.innerHTML = 'It needs to be a valid amount of money';
        errorMessage.style.display = 'block';
        condition = true;
        return true;
    }
}

/*
 * Validate the donation input to make sure it is a number greater than zero
 */
function validateAmount() {
    var errorMessage = document.querySelector('#sos-form-error');
    var value = document.querySelector('#sos-amount').value;
    var button = document.querySelector('.submit');

    if (valueIsPositive(errorMessage, value, button)) {
        condition = false;
        isANumber(errorMessage, value, button);
        if (condition) {
            valueIsPositive(errorMessage, value, button);
            button.removeAttribute('disabled');
        }
    }
}

// Check if there are donation options on the page
if (donateOptions && donateInput) {
    // Loop over each one
    for (var i = 0, len = donateOptions.length; i < len; i++) {

        // Store the current element
        var option = donateOptions[i];

        // Check if the input matched any of the options
        syncInputWithOptions(option);

        // When a user clicks on an opton
        option.addEventListener('click', function() {

            // get the amount stored in the element
            var value = this.getAttribute('data-value');

            // Set the active option
            toggleActiveOption(this);

            // If the user wants a custom amount
            if (value == 'other') {

                // Focux the input
                donateInput.focus();
                // And clear it
                donateInput.value = '';
            } else  {
                // Otherwise set the input value to match the option selected
                donateInput.value = value;

                // Trigger the change event on the input
                var event = new Event('change');
                donateInput.dispatchEvent(event);

                // Update the helper text
                updateConfirmAmount();

                validateAmount();
            }

        });
    }
}

if (donateInput) {
    // When a user has selected the input and moved away then update the form
    donateInput.addEventListener('blur', customDonateAmount);

    // Make sure the helper text is up to date.
    updateConfirmAmount();

    // Validate the input amount on laod
    validateAmount();
}
